import React from "react";
import { formatDateBerlin } from "../App";

// function formatDateBerlin(dateValue) {
//     if (!dateValue) return "";

//     const date = new Date(dateValue);
//     if (Number.isNaN(date.getTime())) return "";

//     return new Intl.DateTimeFormat("de-DE", {
//         timeZone: "Europe/Berlin",
//         day: "2-digit",
//         month: "2-digit",
//         year: "numeric",
//         hour: "2-digit",
//         minute: "2-digit",
//     }).format(date);
// }

function VoucherDisplayCard({ voucherCode, pin, value, expiresAt }) {
    return (
        <div
            style={{
                borderRadius: 12,
                backgroundColor: "#DFFBDF",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    padding: 16,
                    boxSizing: "border-box",
                }}
            >
                <div
                    style={{
                        flex: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                    }}
                >
                    <div
                        style={{
                            fontWeight: "bold",
                            color: "#4D714D",
                            lineHeight: "24px",
                            fontSize: "15px",
                        }}
                    >
                        Code:
                    </div>
                    <div
                        style={{
                            fontWeight: "bold",
                            color: "#4D714D",
                            lineHeight: "24px",
                            fontSize: "15px",
                        }}
                    >
                        PIN:
                    </div>
                    <div
                        style={{
                            fontWeight: "bold",
                            color: "#4D714D",
                            lineHeight: "24px",
                            fontSize: "15px",
                        }}
                    >
                        Guthaben:
                    </div>
                </div>

                <div
                    style={{
                        flex: 3,
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        minWidth: 0,
                    }}
                >
                    <div
                        style={{
                            color: "#4D714D",
                            fontFamily: "monospace",
                            lineHeight: "24px",
                            fontSize: "14px",
                            wordBreak: "break-word",
                        }}
                    >
                        {voucherCode}
                    </div>
                    <div
                        style={{
                            color: "#4D714D",
                            fontFamily: "monospace",
                            lineHeight: "24px",
                            fontSize: "14px",
                            wordBreak: "break-word",
                        }}
                    >
                        {pin}
                    </div>
                    <div
                        style={{
                            color: "#4D714D",
                            fontFamily: "monospace",
                            lineHeight: "24px",
                            fontSize: "14px",
                        }}
                    >
                        {parseFloat(value || 0).toFixed(2).replace(".", ",")} €
                    </div>
                </div>
            </div>

            {expiresAt && (
                <div
                    style={{
                        color: "#353535",
                        fontStyle: "italic",
                        lineHeight: "24px",
                        fontSize: "14px",
                        marginBottom: 8,
                        textAlign: "center",
                        padding: "0 12px",
                    }}
                >
                    Gültig bis: {formatDateBerlin(expiresAt)}
                </div>
            )}
        </div>
    );
}

export default VoucherDisplayCard;